import { TagCommanderMetricMapper } from '@adapters/tagging/tagCommanderMetricMapper';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TagCommanderService } from 'ngx-tag-commander';

@Injectable({
  providedIn: 'root',
})
export class GetAngularDependenciesService {
  constructor(
    private tagCommanderService: TagCommanderService,
    private tagCommanderMetricMapper: TagCommanderMetricMapper,
    private translateService: TranslateService
  ) {
    this.initializeTranslateServiceModule();
  }

  getTagCommanderService(): TagCommanderService {
    return this.tagCommanderService;
  }

  getTagCommanderMetricMapper(): TagCommanderMetricMapper {
    return this.tagCommanderMetricMapper;
  }

  initializeTranslateServiceModule() {
    this.translateService.addLangs(['fr']);
    this.translateService.setDefaultLang('fr');
    const allLangs = this.translateService.getLangs();
    const browserLang = this.translateService.getBrowserLang();

    if (browserLang != null && allLangs.includes(browserLang)) {
      this.translateService.use(browserLang);
    }
  }
}
